import { render, staticRenderFns } from "./ThreeXaxisChart.vue?vue&type=template&id=90f0b4ba&"
import script from "./ThreeXaxisChart.vue?vue&type=script&lang=js&"
export * from "./ThreeXaxisChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports